import { createContext } from 'react'
import { EnrollStepComposerType } from '../types'

export const EnrollStepComposerContext = createContext<EnrollStepComposerType>(
  null
)
